const jobs = {
  bulk: {

    table: {
      direction: {
        distribute: 'Zur Schule',
        collect: 'Von der Schule',
        both: 'Zur Schule & Von der Schule',
      },

    },

    direction: {
      to: 'Zur Schule',
      from: 'Von der Schule',
      both: 'Zur Schule & Von der Schule',
    },

    form: {
      information: {
        details: {
          fields: {
            fromHour: 'Schulbeginn ist um',
            toHour: 'Schulschluss ist um',
            shift: 'Schulzeiten',
            from: 'Privat',
            to: 'Schule',
          },
        },
        locations: {
          header: 'Schule',
          fields: {
            locations: 'Schule Auswählen'
          }
        },
      },
    },
  },

  forms: {
    information: {
      passengers: {
        header: 'Persönliche Informationen',
        label: 'Wählen Sie Schüler aus'
      },
    }
  }
};

export default jobs;
